module.exports = __webpack_public_path__ + "static/img/logo-en.d7135e57.png";